import { helpers, required, requiredIf } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

const { locale } = await useLocale("validation");

export default {
  installmentDebitDay: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  politicallyExposedPerson: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: boolean, { showPEPExplanation }: any) {
        return showPEPExplanation;
      }),
    ),
  },
  iban: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    validIBAN: helpers.withMessage(
      () => locale?.value?.invalid_iban ?? validationJson.invalid_iban,
      Validator.validIban,
    ),
    notPrepaidIBAN: helpers.withMessage(
      () => locale?.value?.invalid_iban ?? validationJson.invalid_iban,
      Validator.notPrepaidIban,
    ),
  },
};
